// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App-loading-wrapper {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  grid-auto-rows: 100px;
  grid-template-areas:
    ". a a ."
    ". a a .";
}
.App-loading-item {
  grid-area: a;
  align-self: center;
  justify-self: center;
  width: 200px;
}
.App-loading-item span {
  display: block;
  text-align: center;
  font-size: 15px;
  margin-bottom: 20px;
}

.app-loading-container {
  padding-top: 36px;
}

.app-loading-card {
  width: 100%;
  max-width: 520px;
  margin: 0 auto;
  padding: 26px 22px 28px;
  border: 0px solid #d1d5db;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.08);
  text-align: center;
}

.app-loading-spinner {
  width: 46px;
  height: 46px;
  margin: 0 auto 18px;
  border-radius: 50%;
  border: 4px solid #b7f0d2;
  border-top-color: #198754;
  animation: app-loading-spin 0.8s linear infinite;
}

.app-loading-title {
  margin: 0;
  font-size: 18px;
  line-height: 1.4;
  color: #1f2937;
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
}

.app-loading-subtitle {
  margin-top: 4px;
  color: #4b5563;
  font-size: 14px;
}

.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

.app-error-container {
  padding-top: 36px;
}

.app-error-card {
  width: 100%;
  max-width: 680px;
  margin: 0 auto;
  padding: 20px 22px;
  border: 0px solid #e5e7eb;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.08);
}

.app-error-title {
  margin: 0 0 10px;
  font-size: 22px;
  line-height: 1.25;
  color: #111827;
}

.app-error-message {
  margin: 0 0 8px;
  font-size: 14px;
  line-height: 1.5;
  color: #b91c1c;
  word-break: break-word;
}

.app-error-hint {
  margin: 0 0 16px;
  font-size: 13px;
  line-height: 1.5;
  color: #4b5563;
}

.app-error-refresh-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 104px;
  height: 36px;
  padding: 0 14px;
  border: none;
  border-radius: 6px;
  background: #166534;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease-in-out;
}

.app-error-refresh-btn:hover {
  background: #14532d;
}

.app-error-badge {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 3px 12px;
  margin-bottom: 14px;
  border: 1px solid #f1bda9;
  border-radius: 999px;
  background: #fff1ea;
  color: #9a3412;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.app-error-message-blocked {
  margin-bottom: 10px;
  font-size: 18px;
  line-height: 1.45;
  color: #0f2b4f;
}

.app-error-steps {
  margin: 0 0 18px 22px;
  padding: 0;
  color: #0f2b4f;
  font-size: 16px;
  line-height: 1.55;
}

.app-error-title-blocked {
  font-size: 24px;
  font-weight: 700;
  color: #0f2b4f;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes app-loading-spin {
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,qBAAqB;EACrB;;aAEW;AACb;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".App-loading-wrapper {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  gap: 10px;\r\n  grid-auto-rows: 100px;\r\n  grid-template-areas:\r\n    \". a a .\"\r\n    \". a a .\";\r\n}\r\n.App-loading-item {\r\n  grid-area: a;\r\n  align-self: center;\r\n  justify-self: center;\r\n  width: 200px;\r\n}\r\n.App-loading-item span {\r\n  display: block;\r\n  text-align: center;\r\n  font-size: 15px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.app-loading-container {\r\n  padding-top: 36px;\r\n}\r\n\r\n.app-loading-card {\r\n  width: 100%;\r\n  max-width: 520px;\r\n  margin: 0 auto;\r\n  padding: 26px 22px 28px;\r\n  border: 0px solid #d1d5db;\r\n  border-radius: 12px;\r\n  background: #ffffff;\r\n  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.08);\r\n  text-align: center;\r\n}\r\n\r\n.app-loading-spinner {\r\n  width: 46px;\r\n  height: 46px;\r\n  margin: 0 auto 18px;\r\n  border-radius: 50%;\r\n  border: 4px solid #b7f0d2;\r\n  border-top-color: #198754;\r\n  animation: app-loading-spin 0.8s linear infinite;\r\n}\r\n\r\n.app-loading-title {\r\n  margin: 0;\r\n  font-size: 18px;\r\n  line-height: 1.4;\r\n  color: #1f2937;\r\n  font-family: \"Open Sans\", sans-serif;\r\n  font-weight: 700;\r\n}\r\n\r\n.app-loading-subtitle {\r\n  margin-top: 4px;\r\n  color: #4b5563;\r\n  font-size: 14px;\r\n}\r\n\r\n.App {\r\n  text-align: center;\r\n}\r\n\r\n.App-logo {\r\n  height: 40vmin;\r\n  pointer-events: none;\r\n}\r\n\r\n@media (prefers-reduced-motion: no-preference) {\r\n  .App-logo {\r\n    animation: App-logo-spin infinite 20s linear;\r\n  }\r\n}\r\n\r\n.App-header {\r\n  background-color: #282c34;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: calc(10px + 2vmin);\r\n  color: white;\r\n}\r\n\r\n.App-link {\r\n  color: #61dafb;\r\n}\r\n\r\n.app-error-container {\r\n  padding-top: 36px;\r\n}\r\n\r\n.app-error-card {\r\n  width: 100%;\r\n  max-width: 680px;\r\n  margin: 0 auto;\r\n  padding: 20px 22px;\r\n  border: 0px solid #e5e7eb;\r\n  border-radius: 10px;\r\n  background: #ffffff;\r\n  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.08);\r\n}\r\n\r\n.app-error-title {\r\n  margin: 0 0 10px;\r\n  font-size: 22px;\r\n  line-height: 1.25;\r\n  color: #111827;\r\n}\r\n\r\n.app-error-message {\r\n  margin: 0 0 8px;\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n  color: #b91c1c;\r\n  word-break: break-word;\r\n}\r\n\r\n.app-error-hint {\r\n  margin: 0 0 16px;\r\n  font-size: 13px;\r\n  line-height: 1.5;\r\n  color: #4b5563;\r\n}\r\n\r\n.app-error-refresh-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 104px;\r\n  height: 36px;\r\n  padding: 0 14px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  background: #166534;\r\n  color: #ffffff;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background-color 0.15s ease-in-out;\r\n}\r\n\r\n.app-error-refresh-btn:hover {\r\n  background: #14532d;\r\n}\r\n\r\n.app-error-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  min-height: 26px;\r\n  padding: 3px 12px;\r\n  margin-bottom: 14px;\r\n  border: 1px solid #f1bda9;\r\n  border-radius: 999px;\r\n  background: #fff1ea;\r\n  color: #9a3412;\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.02em;\r\n}\r\n\r\n.app-error-message-blocked {\r\n  margin-bottom: 10px;\r\n  font-size: 18px;\r\n  line-height: 1.45;\r\n  color: #0f2b4f;\r\n}\r\n\r\n.app-error-steps {\r\n  margin: 0 0 18px 22px;\r\n  padding: 0;\r\n  color: #0f2b4f;\r\n  font-size: 16px;\r\n  line-height: 1.55;\r\n}\r\n\r\n.app-error-title-blocked {\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n  color: #0f2b4f;\r\n}\r\n\r\n@keyframes App-logo-spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n@keyframes app-loading-spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
